import React from "react";
import { Box, Button, Typography, Link } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import sideImg from "../../assets/auth-side.png";

export default function AuthStart() {
  const navigate = useNavigate();

  return (
    <AuthLayout sideImage={sideImg}>
      <Typography variant="h5" sx={{ mb: 1 }}>
        Log in or sign up in seconds
      </Typography>

      <Typography sx={{ color: "text.secondary", mb: 3, maxWidth: 420 }}>
        Use your email to <b>Log in</b> or <b>sign up</b> to continue with NeherBaari.
      </Typography>

      <Button
        fullWidth
        variant="outlined"
        startIcon={<MailOutlineIcon />}
        onClick={() => navigate("/auth/email")}
      >
        Continue with Email
      </Button>

      <Box sx={{ mt: 8 }}>
        <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
          By continuing, you agree to NeherBaari’s{" "}
          <Link
            component="button"
            type="button"
            onClick={() => {}}
            sx={{ color: "primary.main", fontWeight: 800 }}
          >
            Terms of Use
          </Link>
          .
        </Typography>

        <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 0.5 }}>
          Read our{" "}
          <Link
            component="button"
            type="button"
            onClick={() => {}}
            sx={{ color: "primary.main", fontWeight: 800 }}
          >
            Privacy Policy
          </Link>
          .
        </Typography>
      </Box>
    </AuthLayout>
  );
}
